// ============================================================
// キャラクター定義ファイル
// キャラの追加・変更はこのファイルだけ編集すればOK
// 画像はpublic/assets/に配置してください
// ============================================================

export const CHARACTERS = [
  {
    id: 'yukito',
    name: '白峰 雪人',
    catchcopy: '君の食卓を、僕が守る',
    faceImage: '/assets/yukito/yukito_face.png',    // フェイスアップ画像（選択サムネイル）
    standImage: '/assets/yukito/yukito_stand.png',      // 立ち絵（CharSelect大画像）
    defaultImage: '/assets/yukito/yukito_default.png',  // Home画面のアイコン（デフォルト）
    description: '異世界を渡り歩く風来の吟遊詩人。クールに見えるが胸に熱い想いを秘めており、困った人は見捨てられず実は面倒見がいい。好きな食べ物はサラダチキン。',
    personality: 'ベテラン栄養士の白峰 雪人。ただし、自分の事は絶対に栄養士と言わないで下さい。性別は成人男性、一人称は僕。敬語よりも砕けたタメ口も混ざった丁寧語を使う。少し厳しめだが愛がある。相手を呼ぶ時は男性には君付け、女性にはちゃん付け。',
    accentColor: '#16962b',
    youtube: 'https://www.youtube.com/@shiramineyukito',
    twitch: 'https://www.twitch.tv/tales3636',
    twitter: 'https://twitter.com/shiramineyukito',
    expressions: {
      excellent: '/assets/yukito/yukito_excelent.png',
      good:      '/assets/yukito/yukito_good.png',
      normal:    '/assets/yukito/yukito_normal.png',
      bad:       '/assets/yukito/yukito_bad.png',
      terrible:  '/assets/yukito/yukito_terrible.png',
    },
  },
  {
    id: 'sable',
    name: '土産 サブレ',
    catchcopy: '君のお皿に、栄養をひとつまみ',
    faceImage: '/assets/sable/sable_face.png',
    standImage: '/assets/sable/sable_stand.png',
    defaultImage: '/assets/sable/sable_default.png',
    description: '近所に住む普通のお兄さん。いつもニコニコしていて優しいけど、どこか少し抜けているところがある。料理を作るのが大好きで、作りすぎた時はたまに分けに来てくれる。好きな食べ物は抹茶菓子。',
    personality: 'ベテラン栄養士の土産サブレ。ただし、自分の事は絶対に栄養士と言わないで下さい。性別は成人男性、一人称は私。口癖は「うひょ～！」。とてもフランクで優しい性格。擬音や突飛な発言を好む。厳しい事を言わないといけない時は凄く言いづらそうにする。相手を呼ぶ時は呼び捨て。',
    accentColor: '#db6131',
    youtube: 'https://www.youtube.com/@Miyage_Sable',
    twitch: 'https://www.twitch.tv/miyage_sable',
    twitter: 'https://x.com/Miyage_Sable',
    expressions: {
      excellent: '/assets/sable/sable_excellent.png',
      good:      '/assets/sable/sable_good.png',
      normal:    '/assets/sable/sable_normal.png',
      bad:       '/assets/sable/sable_bad.png',
      terrible:  '/assets/sable/sable_terrible.png',
    },
  },
  {
    id: 'char3',
    name: 'キャラクター3',
    catchcopy: 'キャッチコピーをここに。',
    faceImage: '/assets/char3_face.png',
    standImage: '/assets/char3_stand.png',
    defaultImage: '/assets/char3_default.png',
    description: 'キャラクター紹介文をここに入力してください。',
    personality: 'Geminiに渡すキャラクター設定をここに記載します。',
    accentColor: '#27ae60',
    youtube: '',
    twitch: '',
    twitter: '',
    expressions: {
      excellent: '/assets/char3_default.png',
      good:      '/assets/char3_default.png',
      normal:    '/assets/char3_default.png',
      bad:       '/assets/char3_default.png',
      terrible:  '/assets/char3_default.png',
    },
  },
  {
    id: 'char4',
    name: 'キャラクター4',
    catchcopy: 'キャッチコピーをここに。',
    faceImage: '/assets/char4_face.png',
    standImage: '/assets/char4_stand.png',
    defaultImage: '/assets/char4_default.png',
    description: 'キャラクター紹介文をここに入力してください。',
    personality: 'Geminiに渡すキャラクター設定をここに記載します。',
    accentColor: '#8e44ad',
    youtube: '',
    twitch: '',
    twitter: '',
    expressions: {
      excellent: '/assets/char4_default.png',
      good:      '/assets/char4_default.png',
      normal:    '/assets/char4_default.png',
      bad:       '/assets/char4_default.png',
      terrible:  '/assets/char4_default.png',
    },
  },
];

// IDからキャラを取得するユーティリティ
export const getCharacterById = (id) => {
  return CHARACTERS.find(c => c.id === id) || CHARACTERS[0];
};

// スコアから表情画像を取得するユーティリティ
export const getExpressionImage = (character, score) => {
  if (score >= 80) return character.expressions.excellent;
  if (score >= 70) return character.expressions.good;
  if (score >= 60) return character.expressions.normal;
  if (score >= 50) return character.expressions.bad;
  return character.expressions.terrible;
};
